import { DataSourceMode, Layout, EditRowDecorator, LookupModelSelectionEvent, LookupModelSearchEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutCarrierPlanDetail } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierPlanDetail";
import { EditRowDecoratorProps } from "@mcleod/components/src/page/decorators/EditRowDecoratorProps";

export class CarrierPlanDetail extends AutogenLayoutCarrierPlanDetail {

    static showAdd(props:Partial<EditRowDecoratorProps>) {
        const layout = Layout.getLayout('lme/crm/CarrierPlanDetail') as CarrierPlanDetail;

        const erd = new EditRowDecorator({
            layout: layout,
            title: 'Add Carrier Plan Activity',
            overlayProps: { closeOnClickOff: false, greyedBackground: true },
            layoutLoadListeners: [async (event)=> {
                const layout = event.target as CarrierPlanDetail;
                const newRow = await layout.mainDataSource.createBlankRow();
                erd.data = newRow;
                layout.mainDataSource.setRowsAndMode(DataSourceMode.ADD, [newRow]);
            }],
            ...props
        });
    }

    textboxActivityIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.type_of = "A";
        event.filter.id = "!RECCALL";
    }

    textboxActivityIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            const selectedRow = event.selection as ModelRow;
            this.activeRow.set("descr", selectedRow.get("descr"));
        }
    }
}